import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import CourseCombo from '../combos/CourseCombo';
import TeacherCombo from '../combos/TeacherCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Container, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintTeacherSheetDocument from './PrintTeacherSheetDocument';


export default function SchoolTiming(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loadingTiming, setLoadingTiming] = useState(false);
  const [loadingPrintSheet, setLoadingPrintSheet] = useState(false);
  const [addTeacherFormVisible, setAddTeacherFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [printTeacherWorkSheetVisible, setPrintTeacherWorkSheetVisible] = useState(false);
  const [schoolClassDegree, setSchoolClassDegree] = useState(-1);
  const [schoolClassFieldId, setSchoolClassFieldId] = useState("");
  const [schoolClassExist, setSchoolClassExist] = useState(false);
  const [pdfFileIsReady, setPdfFileIsReady] = useState(false);
  const [sheets, setSheets] = useState([]);
  const [school, setSchool] = useState(null);
  const [loadingSheet, setLoadingSheet] = useState(false);
  const [pdfSize, setPdfSize] = useState([800, 1200]);
  const pdfMargin = 10;
  const cols = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ];
  const sheetColWidth = 20;
  const commentColWidth = 70;
  const nameColWidth = 35;
  const sheetHeaderHeight = 50;
  const sheetFooterHeight = 50;
  const sheetCaptionRowHeight = 35;
  const sheetRowHeight = 30;


  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);
  const [schoolClass, setSchoolClass] = useState(null);
  const [teacher, setTeacher] = useState({});
  const [course, setCourse] = useState({});
  const [weekDayIndex, setWeekDayIndex] = useState(0);
  const [timeIndex, setTimeIndex] = useState(0);
  const [currentCourseNumber, setCurrentCourseNumber] = useState(0);

  useEffect(() => {
      setLoadingTiming(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/timing/school/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data.timings;
                  console.log("resopnse is> ", response[0].dayItems);
                  var dp = [];
                  for(var i=0;i<response[0].dayItems.length;i++){
                    dp.push({index:response[0].dayItems[i].timeIndex, title:response[0].dayItems[i].timePart})
                  }
                  setDayParts(dp);
                  setTimings(response);
                  
                  setLoadingTiming(false);
                  if(response[0].dayItems.length>0){
                    if(response[0].dayItems[0].timePartItems){
                      if(response[0].dayItems[0].timePartItems.length >0){ 
                        setSchoolClassExist(true);
                      }
                    }
                  }

              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoadingTiming(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoadingTiming(false);
          });
     
  }, []);

    const saveItem = function(){
      setSaving(true);
      var params = { login: util.getTrustedUser(), schoolClassId:schoolClass.id, teacherId:teacher.id, courseId:course.id, weekDayIndex:weekDayIndex, timeIndex:timeIndex};
      var url = config.Server + `/school/timing/save`;
      console.log("params-->", params);
      axios
      .post(url, params)
      .then(res => {
        var response = res.data;
              if(response.state === "ok"){
                  response = response.data;

                  var tmp = [...timings];
                  for(var i = 0; i<tmp[weekDayIndex].dayItems[timeIndex].timePartItems.length; i++){
                    if(tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].schoolClass.id == schoolClass.id){
                      if(currentCourseNumber == 0){
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id = response.id;
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher = response.teacher;
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course = response.course;
                      }
                      else{
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id2 = response.id;
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher2 = response.teacher;
                        tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course2 = response.course;
                       
                      }
                      break;
                    }
                  }
                  setAddTeacherFormVisible(false);
                  setTimings(tmp);
                  setSaving(false);
              }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

    }
    const onDeleteClick = function(wDayIndex, tIndex, schClass, curCourseNumber, slcTeacher, slcCourse){
      setWeekDayIndex(wDayIndex);
      setTimeIndex(tIndex - 1);
      setSchoolClass(schClass);
      setCurrentCourseNumber(curCourseNumber);
      setCourse(slcCourse);
      setTeacher(slcTeacher);
      setConfirmDeleteVisible(true);
    }
    const onPrintTeacherSheetClick = function(schClass, teacher, course){
      setTeacher(teacher);
      setPdfFileIsReady(false);
      setLoadingSheet(true);
      var params = {login:util.getTrustedUser(), teacherId: teacher.id};
      var url = config.Server+`/school/timing/teacher-class/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response of sheets is>", response)
                  setSheets(response.sheets)
                  setSchool(response.school);
                  
                  

                  var pw = (pdfMargin * 2) + commentColWidth  + (nameColWidth * 3) + ((cols.length + 1) * sheetColWidth);
                  var ph = (pdfMargin * 2) + sheetHeaderHeight + sheetFooterHeight + sheetCaptionRowHeight + (45 * sheetRowHeight);
                  
                  console.log("pw, ph is>", pw, ph)

                  setPdfSize([pw, ph]);
                  
                  setLoadingSheet(false);
                  setPrintTeacherWorkSheetVisible(true);
                  setPdfFileIsReady(true);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoadingSheet(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoadingSheet(false);
          });
      
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
      if(deleting) return;
      setConfirmDeleteVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var params = { login: util.getTrustedUser(), schoolClassId:schoolClass.id, teacherId:teacher.id, courseId:course.id, weekDayIndex:weekDayIndex, timeIndex:timeIndex};
      var url = config.Server + `/school/timing/delete`;
      console.log(params);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...timings];
          for (var i = 0; i < tmp.length; i++) {
            if(tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].schoolClass.id == schoolClass.id){
              if(currentCourseNumber == 1){
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id = tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id2;
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher = tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher2;
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course = tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course2;

                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id2 = "";
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher2 = null;
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course2 = null;

              }
              else{
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].id2 = "";
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].teacher2 = null;
                tmp[weekDayIndex].dayItems[timeIndex].timePartItems[i].course2 = null;
              }
              break;
            }           
          }
          setTimings(tmp);
          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });

    }  
    const editDialogFooter = function () {
      return (
        <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
      )
    }
    const printWorkSheetDialogFooter = function () {
      return (
        <GeneralDialogFooter hideOk={true} onOkClick={() => {  }} onCancelClick={() => { setPrintTeacherWorkSheetVisible(false) }} saving={saving}  />
      )
    }
    const closeEditDialog = function () {
      setAddTeacherFormVisible(false);
    }

    const onComboChange = function (name, value) {
      if(name == "teacher"){
        setTeacher(value);
        console.log("teacher->", value)
      }
      if(name == "course"){
        setCourse(value);
        console.log("Course->", value)
      }
    }

  const btnSelectTeacherClick = function(wDayIndex, tIndex, schClass, curCourseNumber){
    setSchoolClassDegree(schClass.degree);
    setSchoolClassFieldId(schClass.field.id);
    setAddTeacherFormVisible(true);
    setWeekDayIndex(wDayIndex);
    setTimeIndex(tIndex - 1);
    setSchoolClass(schClass);
    setCurrentCourseNumber(curCourseNumber);
  }
  const createSimpleButton = function (weekDayIndex, timeIndex, schoolClass, currentCourseNumber){
    return(
      <div onClick={() => btnSelectTeacherClick(weekDayIndex, timeIndex, schoolClass, currentCourseNumber)} style={{border:"1px solid #b0b0b0", backgroundColor:"#ffffff", color:"#000000", position:"absolute", top:"5px", left:"3px", width:"20px", height:"12px", cursor:"pointer"}}>
        <div style={{backgroundColor:"#8f8e8eff", position:"absolute", top:"4px", left:"3px", width:"2px", height:"2px"}}></div>
        <div style={{backgroundColor:"#8f8e8eff", position:"absolute", top:"4px", left:"7px", width:"2px", height:"2px"}}></div>
        <div style={{backgroundColor:"#8f8e8eff", position:"absolute", top:"4px", left:"11px", width:"2px", height:"2px"}}></div>
      </div>
    );
  }
  return (
    (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
    :
    <div>
      <ShowVideo videoId="school_timing" top={65} md={6} /> 
      <Row>
        <Col md={4} style={{marginTop:"10px"}}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="برنامه ریزی خودکار(ویژه کلاس های ابتدائی)" icon="pi pi-check" onClick={()=>setRedirectUrl("/school/auto-timing")} severity="success" iconPos="right" loading={saving} />
            </div>
        </Col>
        <Col md={4} style={{marginTop:"10px"}}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label=" چاپ برنامه هفتگی" icon="pi pi-check" onClick={()=>setRedirectUrl("/school/print-timing")} severity="success" iconPos="right" loading={saving} />
            </div>
        </Col>
        <Col md={4} style={{marginTop:"10px"}}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label=" جایگزینی معلم در برنامه هفتگی" icon="pi pi-check" onClick={()=>setRedirectUrl("/school/timing/replace/teacher")} severity="success" iconPos="right" loading={saving} />
            </div>
        </Col>
      </Row>
      {
        loadingTiming?
        <>loading...</>
        :
        <Container fluid>
          <Row style={{overflow:"scroll", marginTop:"10px"}}>
            {
              schoolClassExist
              ?<></>
              :
              <Col md={3} style={{backgroundColor:"#ff0", color:"#f00",padding:"5px", borderRadius:"5px", marginBottom:"10px"}}>هیچ کلاسی در سامانه تعریف نشده است</Col>
            }
            <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
              <thead>
                <tr>
                  <td style={{textAlign:"center", width:"70px", padding:"5PX", border:"1px solid #b0b0b0"}}>روز</td>
                  {
                    dayParts.map((zang) => {return (<td style={{textAlign:"center", backgroundColor:"#808080", color:"#fff", padding:"10px 5px", minWidth:"180px"}}>{zang.title}</td>)})
                  }              
                </tr>
              </thead>
              <tbody>
                {timings.map((day) => 
                  <tr>
                    <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>{day.weekDayName}</td>
                    {
                    day.dayItems.map((col) => 
                      <td style={{padding:'10px', textAlign:'center', border:"1px solid #b0b0b0"}}>        
                            {
                              col.timePartItems.map((cls)=>{
                                return(
                                  (cls.teacher == null)?
                                  <div style={{border:"1px solid #e06b6bff", backgroundColor:"#aa3333", color:"#ffffff", position:"relative"}}>
                                    {cls.schoolClass.name}
                                    {createSimpleButton(day.weekDayIndex, col.timeIndex, cls.schoolClass, 0)}
                                  </div>
                                  :
                                  (cls.teacher2 == null)?
                                  <div style={{border:"1px solid #02701eff", backgroundColor:"#daf7e3ff", color:"#000000", position:"relative"}}>
                                    {cls.schoolClass.name}
                                    {createSimpleButton(day.weekDayIndex, col.timeIndex, cls.schoolClass, 1)}
                                    <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                      <div title={cls.teacher.firstname + " " + cls.teacher.lastname + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"right", fontSize:"8pt"}}>
                                        {cls.teacher.firstname}&nbsp;{cls.teacher.lastname} - {cls.course.name}
                                      </div>
                                      <img onClick={() => onPrintTeacherSheetClick(cls.schoolClass, cls.teacher,  cls.course)} src={require("../lib/images/print_16.png")} style={{width:"16px", height:"16px", position:"absolute", left:"26px", top:"5px", cursor:"pointer"}} title='چاپ کاربرگ معلم' />
                                      <img onClick={() => onDeleteClick(day.weekDayIndex, col.timeIndex, cls.schoolClass, 1, cls.teacher,  cls.course)} src={require("../lib/images/delete_icon.png")} style={{width:"16px", height:"16px", position:"absolute", left:"5px", top:"5px", cursor:"pointer"}} title='حذف' />
                                    </div>
                                  </div>
                                  :
                                  <div style={{border:"1px solid #faae82ff", backgroundColor:"#f7dbc5ff", color:"#000000", position:"relative"}}>
                                    {cls.schoolClass.name}
                                    <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                      <div title={cls.teacher.firstname + " " + cls.teacher.lastname + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"right", fontSize:"8pt"}}>
                                        {cls.teacher.firstname}&nbsp;{cls.teacher.lastname} - {cls.course.name}
                                      </div>
                                      <img onClick={() => onPrintTeacherSheetClick(cls.schoolClass, cls.teacher,  cls.course)} src={require("../lib/images/print_16.png")} style={{width:"16px", height:"16px", position:"absolute", left:"26px", top:"5px", cursor:"pointer"}} title='چاپ کاربرگ معلم' />
                                      <img onClick={() => onDeleteClick(day.weekDayIndex, col.timeIndex, cls.schoolClass, 1, cls.teacher,  cls.course)} src={require("../lib/images/delete_icon.png")} style={{width:"16px", height:"16px", position:"absolute", left:"5px", top:"5px", cursor:"pointer"}} title='حذف' />
                                    </div>
                                    <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                      <div title={cls.teacher2.firstname + " " + cls.teacher2.lastname + " - " + cls.course2.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"right", fontSize:"8pt"}}>
                                        {cls.teacher2.firstname}&nbsp;{cls.teacher2.lastname} - {cls.course2.name}
                                      </div>
                                      <img onClick={() => onPrintTeacherSheetClick(cls.schoolClass, cls.teacher2,  cls.course2)} src={require("../lib/images/print_16.png")} style={{width:"16px", height:"16px", position:"absolute", left:"26px", top:"5px", cursor:"pointer"}} title='چاپ کاربرگ معلم' />
                                      <img onClick={() => onDeleteClick(day.weekDayIndex, col.timeIndex, cls.schoolClass, 2, cls.teacher2,  cls.course2)} src={require("../lib/images/delete_icon.png")} style={{width:"16px", height:"16px", position:"absolute", left:"5px", top:"5px", cursor:"pointer"}} title='حذف' />
                                    </div>
                                  </div>
                                )
                              })
                            }
                      </td>)
                    }
                  </tr>)}
              </tbody>
            </table>
          </Row>
        </Container>
      }
      {
        addTeacherFormVisible?
        <Dialog visible={true} onHide={()=>{closeEditDialog()}} footer={editDialogFooter} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          header="ثبت معلم و درس" modal className="p-fluid">
            <TeacherCombo returnFullItem={true} value={teacher} onChange={(val) => onComboChange('teacher', val)}/>
            <CourseCombo returnFullItem={true} degree={schoolClassDegree} fieldId={schoolClassFieldId} value={course} onChange={(val) => onComboChange('course', val)}/>
        </Dialog>
        :
        <></>
      }
      {
        printTeacherWorkSheetVisible?
        <Dialog visible={true} onHide={()=>{setPrintTeacherWorkSheetVisible(false)}} footer={printWorkSheetDialogFooter} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          header="چاپ کاربرگ معلم" modal className="p-fluid">
            <div>&nbsp;</div>
            <div>معلم: {teacher.firstname} &nbsp; {teacher.lastname}</div>
            <div>&nbsp;</div>
              <PDFDownloadLink  style={{textDecoration:"0px"}}                  
                  document={<PrintTeacherSheetDocument 
                    teacher={teacher}
                    school={school}
                    sheets={sheets}
                    pdfSize={pdfSize}
                    margin={pdfMargin}
                    headerHeight={sheetHeaderHeight}
                    footerHeight={sheetFooterHeight}
                    captionRowHeight={sheetCaptionRowHeight}
                    fontSize={12}
                  />} fileName={"teacher_worksheet_"+util.generateRandomUString(10)+".pdf"}>
                    {
                      pdfFileIsReady?
                      <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کاربرگ معلم</label>
                      :
                      <>درحال آماده سازی فایل...</>
                    }
                {
                  // ({ blob, url, loading, error }) =>
                  // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                }
              </PDFDownloadLink>
            
        </Dialog>
        :
        <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </div>
  );
}
